import { Link } from "react-router-dom";
import type { Movie } from "@/types";
import StarRating from "@/components/base/StarRating";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} - ${movie.genres.join(" ")} - 棒棒TV影视推荐`}
          title={`${movie.title} 影视详情 - 棒棒TV`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
          {movie.region}
        </span>
        <span className="absolute bottom-2 right-2 rounded-md bg-black/55 px-2 py-0.5 text-[11px] font-semibold text-secondary-300 backdrop-blur">
          {movie.year}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.genres.slice(0, 3).join(" · ")}
        </p>
        <div className="mt-2 flex items-center justify-between">
          <StarRating value={movie.rating} />
          <span className="flex items-center gap-1 text-[11px] text-accent-600">
            <i className="ri-fire-line"></i>
            {(movie.hotness / 1000).toFixed(1)}k
          </span>
        </div>
      </div>
    </Link>
  );
}